import { appConstants } from "JS/Helpers/Constants";
import { config } from "JS/Config";
import {
    IncomeDisclosure,
    IncomeDisclosureAcceptanceResponse,
    IncomeDisclosureFile,
} from "JS/Models/IncomeDisclosure";
import { BaseService } from "../BaseService";

const isValidDisclosure = (disclosure?: IncomeDisclosure) => {
    const version = disclosure?.version;
    const hasVersion =
        version !== undefined && version !== null && version !== "";
    return hasVersion && !!disclosure?.en?.heading && !!disclosure?.en?.body;
};

export class IncomeDisclosureService extends BaseService {
    async getIncomeDisclosure(): Promise<IncomeDisclosure> {
        const filePath = config.s3.incomeDisclosure.key;
        if (!filePath) {
            throw new Error("Income disclosure file path is not configured");
        }
        const response = await this.ngCall<IncomeDisclosureFile>(
            "get",
            appConstants.ngEndpoints.s3File,
            {
                params: {
                    bucketName: config.s3.mediaEssentials.bucketName,
                    filePath,
                },
            },
        );
        const disclosure = response.data?.income_disclosure;
        if (!isValidDisclosure(disclosure)) {
            throw new Error("Invalid income disclosure file");
        }
        return disclosure;
    }

    async acceptIncomeDisclosure(
        version: IncomeDisclosure["version"],
        acceptedAt: number,
    ): Promise<IncomeDisclosureAcceptanceResponse> {
        const response = await this.ngCall<IncomeDisclosureAcceptanceResponse>(
            "post",
            appConstants.ngEndpoints.disclosureAcceptance,
            {
                userId: config.user.memberId,
                userType: "member",
                appName: "media-web",
                version: String(version),
                acceptedAt,
            },
        );
        if (!response.data?.id) {
            throw new Error("Income disclosure acceptance was not recorded");
        }
        return response.data;
    }
}
